import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MyIcon } from "../../common/baseConfig";
import { Button, Modal } from "antd"
import * as actions from './redux/actions';

let sec = 0, min = 0, hour = 0;

export class TimePane extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    time: "00:00:00",
    visible: false,
  }
  timer = null;
  componentDidMount() {
    this.startTimer();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.quesStore.checkAllPars) {
      clearInterval(this.timer);
    }
  }
  startTimer() {
    this.timer = setInterval(() => {
      sec++;
      if (sec >= 60) {
        sec = 0;
        min++;
        if (min >= 60) {
          sec = 0;
          min = 0;
          hour++;
        }
      }
      this.setState({
        time: `${hour < 10 ? "0" + hour : hour}:${min < 10 ? "0" + min : min}:${sec < 10 ? "0" + sec : sec}`
      })
    }, 1000);
  }
  componentWillUnmount() {
    sec = min = hour = 0;
    clearInterval(this.timer);
  }
  render() {
    const { time, visible, } = this.state;
    const { checkAllPars } = this.props.quesStore;
    return (
      <div className="ques-store-time-pane">
        <div className="useTime">
          <div className="useTime-left">
            <MyIcon type="iconxuexijilu" className="clock" />
            <span className="tit">用时:</span>
            <span className="time">{time}</span>
          </div>
          {
            !checkAllPars && <div className="useTime-right" onClick={() => {
              this.setState({
                visible: true,
              }, () => {
                clearInterval(this.timer)
              })
            }}>
              <MyIcon type="iconzanting" className="stop" />
              <span className="tit">暂停</span>
            </div>
          }
        </div>
        <Modal
          wrapClassName="stopExerModal"
          centered
          maskClosable={false}
          title={null}
          footer={null}
          width={400}
          onCancel={() => {
            this.setState({
              visible: false,
            }, () => {
              this.startTimer();
            })
          }}
          visible={visible}
        >
          <div className="content">
            <img src={require("../../images/stop.png")} alt="" />
            <Button type="theme" onClick={() => {
              this.setState({
                visible: false,
              }, () => {
                this.startTimer();
              })
            }}>继续做题</Button>
          </div>
        </Modal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimePane);



// WEBPACK FOOTER //
// ./src/features/ques-store/TimePane.js